<template>
  <div>
    <!-- <p class="desc">选择能发起该审批的人员/部门，不选则默认开放给所有人</p> -->
     <div class="sub-title">设置发起人</div>
     <div class="sub-title-tips">发起人范围</div>
    <!-- <el-button size="mini" @click="selectOrg" icon="el-icon-plus" type="primary" plain>添加</el-button> -->
    <!-- <org-items v-model="select"/> -->
    <el-select v-model="setup.whoCommit" @click.native="selectUser" @remove-tag="removeTag" value-key="name"
                class="select-u" placeholder="发起人范围"
                size="medium" multiple popper-class="hidden">
      <el-option v-for="(wc, index) in setup.whoCommit" :label="wc.name" :key="index" :value="wc"></el-option>
    </el-select>
    <org-picker title="发起人范围" multiple ref="orgPicker" :selected="select" @ok="selected"/>
  </div>
</template>

<script>
import OrgPicker from "@/components/OrgPicker";
import OrgItems from "../OrgItems";

export default {
  name: "RootConfig",
  components: {OrgPicker, OrgItems},
  props:{
    config:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {
      showOrgSelect: false
    }
  },
  computed:{
    select(){
      return this.config.assignedUser
    },
    setup() {
      return {...this.$store.state.design}
    }
  },
  methods: {
    selectOrg() {
      this.$refs.orgPicker.show()
    },
    selectUser() {
      // console.log('hi>>',this.$store.state.design.whoCommit)
      this.$refs.orgPicker.show(this.$store.state.design.whoCommit)
    },
    removeTag(item){
      // console.log('>>',item)
      let newSelect = this.$store.state.design.whoCommit.filter(e=>e.id!=item.id)
      this.setForm(newSelect,'whoCommit',)
    },
    selected(select) {
      this.setup.whoCommit = select
      this.setForm(select,'whoCommit',)
    },
    setForm(value,key){
      this.$store.commit("updateBase",{key,value});
    }
    // selected(select) {
    //   this.select.length = 0
    //   select.forEach(val => this.select.push(val))
    // },
    // removeOrgItem(index){
    //   this.select.splice(index, 1)
    // }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .select-u {
  width: 100%;
}
.sub-title{
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #2F3030;
  padding: 2px 0 10px 0;
}
.sub-title-tips{
  font-family: PingFang SC, PingFang SC;
  font-weight: normal;
  font-size: 13px;
  color: #2F3030;
  padding-bottom: 10px;
}
.desc{
  font-size: small;
  color: #8c8c8c;
}
.org-item{
  margin: 5px;
}
</style>
